<template>
    <div class="tab-panel padded">
        <resource-form @toggleIsDisabled="toggleIsDisabled" @readyToSave="readyToSave"></resource-form>

        <div class="d-flex justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled">Save</button>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ResourceForm from './ResourceForm'

    export default {
        data: function() {
            return {
                isDisabled: true,
                updatedForm: null,
            }
        },
        created: function() {
            this.updatedForm = this.getSelectedItem ? JSON.parse(JSON.stringify(this.getSelectedItem)) : {};
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'account',
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'updateItem',
                'clearSelectedItem'
            ]),
            toggleIsDisabled: function(isDisabled) {
                this.isDisabled = isDisabled;
            },
            cancel: function() {
                this.clearSelectedItem();
                this.closeModal();
            },
            readyToSave: function(updatedForm) {
                this.updatedForm = updatedForm;
            },
            save: function() {
                this.updateItem({
                    object: 'resource',
                    action: this.getSelectedItem ? 'edit' : 'create',
                    table: 'resources',
                    fields: { supplierId: this.account.supplierId, resource: this.updatedForm }
                });
            }
        },
        components: {
            ResourceForm,
        }
    }
</script>


// WEBPACK FOOTER //
// ResourceEdit.vue?426bb2da